import * as angular from "angular";
import { Endpoints } from "../../shared/config/constant.module";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import HttpServiceName, { HttpService } from "../http/http.service";

let requires = [HttpServiceName];


export interface MeasureService {
  exportToCSV(plantId: string, startDate: Date, endDate: Date,shops: string[],item: string ): angular.IPromise<any>;
  wxgexportToCSV(plantId: string, startDate: Date, endDate: Date, type: number): angular.IPromise<any>;
  getPlantItems(plantId: string);
}

class measureServiceImpl implements MeasureService {
  private httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  } 

  getPlantItems(plantId: string) {
    return this.httpService.get(Endpoints.MEASURE_PLANT_ITEMS,{plantId: plantId});
  }

  exportToCSV(plantId: string, startDate: Date, endDate: Date, shops: string[],item:string) {

    let req = {
        plantId: plantId,
        startDate: startDate.toLocaleString(),
        endDate: endDate.toLocaleString(),
        shopIds: shops,
        item: item
      };
    return this.httpService.post<any>(Endpoints.MEASURE_MINILAB,req);
  }

  wxgexportToCSV(plantId: string, startDate: Date, endDate: Date, type : number) {

    let req = {
        plantId: plantId,
        startDate: startDate.toLocaleString(),
        endDate: endDate.toLocaleString(),
      };
    return this.httpService.post<any>(Endpoints.MEASURE_WXG+'?type='+ type,req);
  }
}


export default angular
  .module('aps.services.measureService', [HttpServiceName])
  .service('measureService', measureServiceImpl)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/dashboard/measure.service.ts